"use client";

import { VenetianMask, X } from "lucide-react";
import { useRouter } from "next/navigation";
import { useMasquerade } from "@/contexts/masquerade-context";

const formatWallet = (wallet: string) =>
  wallet.length > 12 ? `${wallet.slice(0, 6)}…${wallet.slice(-4)}` : wallet;

/**
 * Site-wide banner shown whenever an admin is "viewing as" another wallet, so
 * impersonation is never silent. Exit clears the masquerade and returns to the
 * admin console.
 */
export function MasqueradeBanner() {
  const { impersonatedWallet, isMasquerading, stopMasquerade } =
    useMasquerade();
  const router = useRouter();

  if (!isMasquerading || !impersonatedWallet) return null;

  const handleExit = () => {
    stopMasquerade();
    router.push("/admin");
  };

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 bg-spicenet-primary px-4 py-2 text-white">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em]">
        <VenetianMask className="h-4 w-4 shrink-0" />
        <span>
          Viewing as{" "}
          <span className="font-mono normal-case tracking-normal">
            {formatWallet(impersonatedWallet)}
          </span>
        </span>
      </div>
      <button
        type="button"
        onClick={handleExit}
        className="flex items-center gap-1.5 border border-white/60 px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] transition-colors duration-200 ease-out hover:bg-white hover:text-spicenet-primary"
      >
        <X className="h-3.5 w-3.5" />
        Exit
      </button>
    </div>
  );
}
